import React, { useState, useEffect,createRef  } from "react";
import Skeleton from '@material-ui/lab/Skeleton';
import Header from './Header';
import Name from './Name';
import Repo from './Repo';
import About from './About';
import Particle from "./Particle";
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import {useLocation} from 'react-router-dom'
import Particles from 'react-particles-js';
import particlesConfig from './../particlesjs-config.js';
import './../App.css'

function Portfolio() {
    const location = useLocation() 
    //console.log(location.state.username) 
    const username = location.state.username
    console.log(username)
    const [loading,setLoading] = useState(true);
    const [userData,setUserData] = useState({});
    const [repoData,setRepoData] = useState({});
    const [aboutHtml,setAboutHtml] = useState({});
    const [originalUserDataLength,setOriginalUserDataLength] = useState(0);
    const [aboutMeAvailable,setAboutMeAvailable] = useState(true);
    const githubUserName = location.state.username;
    //const githubUserName = 'parmaraakash7';
    //const githubUserName = 'JeetShah25';
    //const githubUserName = 'iampawan';
    const api = 'https://api.github.com';
    const token = "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";

    const scrollDivAboutMe = createRef();
    const scrollDivProjects = createRef();

    useEffect(() => {

        getAllDetails();
    }, []);

    const scrollAboutHandler = () => {
        scrollDivAboutMe.current.scrollIntoView({ behavior: "smooth" });
    };

    const scrollProjectsHandler = () => {
        scrollDivProjects.current.scrollIntoView({ behavior: "smooth" });
    };

    const getAllDetails = async () => {
        const userDetails = await fetch(
            `${api}/users/${githubUserName}`,
            {
                headers: {
                  authorization: `${token}`
                }
            }
        );
        const aboutDetails = await fetch(
            `${api}/repos/${githubUserName}/${githubUserName}/readme`,
            {
                headers: {
                  authorization: `${token}`,
                  Accept: "application/vnd.github.v3.html"
                }
            }
        );
        const repoDetails = await fetch(
            `${api}/users/${githubUserName}/repos`,
            {
                headers: {
                  authorization: `${token}`
                }
            }
        );

        if(aboutDetails.status === 404){
            setAboutMeAvailable(false);
        }
        else{
            const temp = (await aboutDetails.text()).valueOf();
            setAboutHtml(temp);
        }
        const userDataJson = await userDetails.json();
        const repoDataJson = await repoDetails.json();
        setOriginalUserDataLength(repoDataJson.length);
        repoDataJson.sort((repoOne,repoTwo)=>(repoOne.watchers_count > repoTwo.watchers_count ) ? -1 : 1);
        repoDataJson.splice(6,repoDataJson.length)
        setUserData(userDataJson);
        setRepoData(repoDataJson);
        setLoading(false);
    };


    if(loading){
        return (
            <div>
                <Particles height="100%" width="100%" params={particlesConfig} />
                
            </div>
        )
    }
    else{
        return (
            <div>
                <Particles height="1500%" width="100%" params={particlesConfig} />
                <div class="z-content">
                <Header
                    name={userData.name===null ? githubUserName : userData.name} 
                    aboutMe={aboutMeAvailable}
                    linkToAbout={scrollAboutHandler}
                    linkToProjects={scrollProjectsHandler}
                />
                <Name 
                    alt={userData.name===null ? githubUserName : userData.name}
                    avatar={userData.avatar_url}
                    bio={userData.bio}
                    company={userData.company}
                    location={userData.location}
                    website={userData.blog}
                    followers={userData.followers}
                />
                {
                    aboutMeAvailable ? <div ref={scrollDivAboutMe}>
                    <About 
                        htmlData={aboutHtml}
                    />
                    </div>
                    : 
                    <div></div>
                }
                
                <div ref={scrollDivProjects}>
                <Repo 
                    userData={repoData}
                    originalUserDataLength={originalUserDataLength}
                />
                </div>
                </div>
                
                
            </div>
        )
    }
    
}

export default Portfolio
